var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paid_BJ"
  }, [_c('div', {
    staticClass: "paid_top"
  }, [_c('img', {
    staticClass: "paid_bg",
    attrs: {
      "src": "/static/img/paid_bg_BJ.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/paid_logo_BJ.png"
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "paid_h3"
  }, [_vm._v("恭喜您,合同已签订完成")]), _vm._v(" "), _c('div', {
    staticClass: "paid_h4"
  }, [_vm._v("欢迎使用众赢投顾服务")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-420bc242","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/customer/NoQyServiceOrderDone.vue
// module id = 236
// module chunks = 0